import React from 'react'
import styles from './Home.module.css'

const Home = () => {
	return (
		<div className={styles.container}>
			<h1>Real time Stock Trading simulator</h1>
			<h2>Free and Open source made with MongoDB, Express, React and Node.js</h2>
		</div>
	)
}

export default Home
